/* eslint-disable prettier/prettier */
//import { computed } from "vue"
import { useStore } from "vuex"

const addTransfersDepartures = () =>{
    const store = useStore()
    const sendAddtransferDeparture = async (data) => {
         const resp = await store.dispatch("addTransfersDepartures/sendAddtransferDeparture",data)
         return resp
    }
    const getList = async (data) => {
        const resp = await store.dispatch("addTransfersDepartures/getList",data)
        return resp
    }
    const uploadFile = async(data)=>{
        const resp = await store.dispatch("addTransfersDepartures/uploadFile", data)
        return resp
    }
    const uploadFileRevocation = async(data)=>{
        const resp = await store.dispatch("addTransfersDepartures/uploadFileRevocation", data)
        return resp
    }
    const resolution = async (data)=> {
        const resp = await store.dispatch("addTransfersDepartures/printResolution", data)
        return resp
    }
    const resolutionRevocation = async (data)=> {
        const resp = await store.dispatch("addTransfersDepartures/printResolutionRevocation", data)
        return resp
    }
    const deleteFile = async(data)=>{
        const resp = await store.dispatch("addTransfersDepartures/deleteFile", data)
        return resp
    }
    const deleteFileRevocation = async(data)=>{
        const resp = await store.dispatch("addTransfersDepartures/deleteFileRevocation", data)
        return resp
    }
    const receive_transfer = async (data)=>{
        const resp = await store.dispatch("addTransfersDepartures/receive_transfer", data)
        return resp
    }
    const get_dataOrders_ppl = async (data)=>{
        const resp = await store.dispatch("addTransfersDepartures/get_dataOrders_ppl", data)
        return resp
    }
    const approve_liberty_ppl = async (data) => {
        const resp = await store.dispatch("addTransfersDepartures/approve_liberty_ppl", data)
        return resp
    }
    const deny_liberty_ppl = async (data) => {
        const resp = await store.dispatch("addTransfersDepartures/deny_liberty_ppl", data)
        return resp
    }
    const turn_principal_order = async (data) => {
        const resp = await store.dispatch("addTransfersDepartures/turn_principal_order", data)
        return resp
    }
    const printAddTransferDeparture = async (data) => {
        const resp = await store.dispatch("addTransfersDepartures/print_add_transfer_departure", data)
        return resp
    }
    const repeal_order = async (data) => {
        const resp = await store.dispatch("addTransfersDepartures/repeal_order", data)
        return resp
    }
    const register_order_departure = async (data) => {
        const resp = await store.dispatch("addTransfersDepartures/register_order_departure", data)
        return resp
    }
    const get_types_of_deaths = async (data) => {
        const resp = await store.dispatch("addTransfersDepartures/get_types_of_deaths", data)
        return resp
    }
    const send_recapture = async (data) => {
        const resp = await store.dispatch("addTransfersDepartures/send_recapture", data)
        return resp
    }
    return{
        sendAddtransferDeparture,
        getList,
        uploadFile,
        uploadFileRevocation,
        resolution,
        resolutionRevocation,
        deleteFile,
        deleteFileRevocation,
        receive_transfer,
        get_dataOrders_ppl,
        approve_liberty_ppl,
        deny_liberty_ppl,
        turn_principal_order,
        printAddTransferDeparture,
        repeal_order,
        register_order_departure,
        get_types_of_deaths,
        send_recapture
    }
    
};

export default addTransfersDepartures